/* Collection cards: "$29.99 each with 2+". Liquid prints USD math; outside USD convert the $5 at Shopify's rate. */
(function(){
  if(window.__edc2)return; window.__edc2=1;
  function fmt(c,mf){var m=String(mf||'$1,234.56').match(/^(.*?)1(\D?)234(?:(\D)56)?(.*)$/)||[0,'$',',','.',''];c=Math.round(c);var w=String(Math.floor(c/100)).replace(/\B(?=(\d{3})+(?!\d))/g,m[2]||''),f=('0'+(c%100)).slice(-2);return m[1]+w+(m[3]?m[3]+f:'')+m[4]}
  function run(){
    var S=window.Shopify||{}, cur=S.currency||{}; if(!cur.active||cur.active==='USD')return;
    var D=Math.round(500*(parseFloat(cur.rate)||1));
    var els=document.querySelectorAll('.edc2-b:not([data-done])');
    for(var i=0;i<els.length;i++){var b=els[i];b.setAttribute('data-done','1');b.textContent=fmt(+b.getAttribute('data-c')-D,b.getAttribute('data-mf'))}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  var count=null;
  function cartLabels(){
    document.querySelectorAll('.edc2').forEach(function(el){
      var label=el.querySelector('small'),one=el.nextElementSibling;
      if(count===null)return;
      var text=count>0?'each with your cart':'each with any 2+ items';
      if(label&&label.textContent!==text)label.textContent=text;
      if(one&&one.classList.contains('edc2-one'))one.style.display=count>0?'none':'block';
    });
  }
  var prices=run;run=function(){prices();cartLabels()};
  function refresh(){fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart.js').then(function(r){if(!r.ok)throw Error('Cart unavailable');return r.json()}).then(function(c){count=c.item_count;run()}).catch(function(){})}
  document.addEventListener('edct:cart',function(e){count=e.detail.item_count;run()});
  window.addEventListener('pageshow',refresh);refresh();
  var t; if('MutationObserver' in window)new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,60)}).observe(document.documentElement,{childList:true,subtree:true});
})();
